module.exports = __webpack_public_path__ + "static/beniakovce-60cb7e7e2474a4d6dd929ff5cf2dd996.svg";